export const featurePermissionsList = {
	library: {
		featureId: 'FeaXDl5cijPz0ijQJQJg0SmxA',
		name: 'Library',
		description: 'SETTING_USER_PERMISSIONS_MEDIA_LIBRARY_DESCRIPTION',
		type: 'userPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_MEDIA_LIBRARY_NAME',
	},
	publish: {
		featureId: 'FeaHZxk2329Y0qja4hc9Fknow',
		name: 'Publish',
		description: 'SETTING_USER_PERMISSIONS_ACCESS_RESTRICTIONS_DESCRIPTION',
		type: 'userPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_ACCESS_RESTRICTIONS_NAME',
	},
	analytics: {
		featureId: 'FeaQVkhwYEcY0O0Q3JxCGYg3Q',
		name: 'Analytics',
		description: 'SETTING_USER_PERMISSIONS_ANALYTICS_DESCRIPTION',
		type: 'userPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_ANALYTICS_NAME',
	},
	account: {
		featureId: 'FeaEUXAlmqRxESo2pUmqecqPQ',
		name: 'Account',
		description: 'SETTING_USER_PERMISSIONS_ACCOUNT_DESCRIPTION',
		type: 'administratorPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_ACCOUNT_NAME',
	},
	play2: {
		featureId: 'FeapizSC0CeWE6whJOlQ3jxUw',
		name: 'Play2',
		isNoLongerUsed: true,
	},
	administration: {
		featureId: 'FeamQapwN2dokG5ImHB2frVYg',
		name: 'Administration',
		isNoLongerUsed: true,
	},
	usersAndFeatures: {
		featureId: 'Feaf1atQZWrAUy9kuZUsFPg0w',
		name: 'Users and features',
		description: 'SETTING_USER_PERMISSIONS_USER_ADMIN_DESCRIPTION',
		type: 'administratorPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_USER_ADMIN_NAME',
	},
	interact: {
		featureId: 'FeaDiiUrPmmt0xLtC3BjFAzCQ',
		name: 'Interact [Legacy]',
		isNoLongerUsed: true,
	},
	legacy_ovp: {
		featureId: 'Fea0czhs0DMu0mPYnEY57hcQA',
		name: 'legacy_ovp',
		isNoLongerUsed: true,
	},
	apps: {
		featureId: 'FeaPJKTZ0ozgkWLhKkBnrGLHg',
		name: 'Apps',
		description: 'SETTING_USER_PERMISSIONS_CUSTOM_APPS_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_CUSTOM_APPS_NAME',
	},
	channels: {
		featureId: 'FeaKvNQx4xLXkWtyXcofZUh9Q',
		name: 'Channels',
		description: 'SETTING_USER_PERMISSIONS_LIVE_MANAGER_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_LIVE_MANAGER_NAME',
	},
	scenarios: {
		featureId: 'Feak7oTx1NPqkWXAoFs2iswJA',
		name: 'Scenarios',
		description: 'SETTING_USER_PERMISSIONS_INTERACT_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_INTERACT_NAME',
	},
	legacyLive: {
		featureId: 'Fea1xTSdbQcH0Kl8jMVX6roVQ',
		name: 'Legacy live',
		description: 'SETTING_USER_PERMISSIONS_LEGACY_LIVE_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_LEGACY_LIVE_NAME',
	},
	speech2Text: {
		featureId: 'Feaxxz1cw3xWUCZ7JKqFteVxA',
		name: 'Speech2Text',
		description: 'SETTING_USER_PERMISSIONS_SPEECH_TO_TEXT_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_SPEECH_TO_TEXT_NAME',
	},
	ingest: {
		featureId: 'FeaBnbWlTSrCExM1tpAdQnKkQ',
		name: 'Ingest',
		description: 'SETTING_USER_PERMISSIONS_VIDEO_UPLOAD_DESCRIPTION',
		type: 'userPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_VIDEO_UPLOAD_NAME',
	},
	adobeExpress: {
		featureId: 'FeaHM2IjQ7xz0yWufDEWOql3A',
		name: 'Adobe Express',
		description: 'SETTING_USER_PERMISSIONS_ADOBE_EXPRESS_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_ADOBE_EXPRESS_NAME',
	},
	accountAdmin: {
		featureId: 'Feaywn4KxuYIk27FPbbp0xWxw',
		name: 'Account Admin',
		description: 'SETTING_USER_PERMISSIONS_CATALOG_ADMIN_DESCRIPTION',
		type: 'administratorPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_CATALOG_ADMIN_NAME',
	},
	portals: {
		featureId: 'FeaRauYHNYozkmHUPvA7jujiQ',
		name: 'Portals',
		description: 'SETTING_USER_PERMISSIONS_PORTALS_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_PORTALS_NAME',
	},
	viewerEngagement: {
		featureId: 'FeaqNLpcDv7bkGJVqdJ94YrOQ',
		name: 'Chat',
		description: 'SETTING_USER_PERMISSIONS_CHAT_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_CHAT_NAME',
	},
	QbrickPlayerEditor: {
		featureId: 'FeaLHTFUn7E0UmQOosx8sLy9g',
		name: 'QbrickPlayerEditor',
		description: 'SETTING_USER_PERMISSIONS_PLAYER_SETTINGS_DESCRIPTION',
		type: 'administratorPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_PLAYER_SETTINGS_NAME',
	},
	InteractiveEditor: {
		featureId: 'FeaTbfRxlhW7UamJv5Hr8dChA',
		name: 'InteractiveEditor',
		description: 'SETTING_USER_PERMISSIONS_CHAPTERS_AND_TRIM_DESCRIPTION',
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_CHAPTERS_AND_TRIM_NAME',
	},
	portalAdmin: {
		featureId: 'FeayxKeuXvsKk2JcR98lvEeFA',
		name: 'Portal admin',
		description: 'SETTING_USER_PERMISSIONS_PORTAL_ADMIN_DESCRIPTION',
		type: 'administratorPermissions',
		displayLabel: 'SETTING_USER_PERMISSIONS_PORTAL_ADMIN_NAME',
	},
	forms: {
		name: "Forms",
		featureId: "FeatzjwRx8i4ECQUMfvNDxjfw",
		accessLevel: 2,
		type: 'products',
		displayLabel: 'SETTING_USER_PERMISSIONS_FORMS_NAME',
		description: 'SETTING_USER_PERMISSIONS_FORMS_DESCRIPTION',
	}
};

export const PERMISSION_TYPE = {
	administratorPermissions: 'administratorPermissions',
	userPermissions: 'userPermissions',
	products: 'products',
};

export const ACCESS_LEVEL = {
	NONE: 0,
	READ: 1,
	READ_WRITE: 2,
};
